export default {
  home: {
    describe1: "Welcome to use",
    describe2: "Make the world just a fingertip away",
    describe3: "With perfect cross-platform solutions, it is based on network platform and adopts distributed regional management technology, which can effectively integrate various multimedia resources and achieve remote production, release and management of programs."
  },
  app: {
    more: "viewMore",
    PersonalCenter: "Trung tâm cá nhân",
    HelpDocument: "Tài liệu hỗ trợ",
    LogOut: "LogOut",
    AddMaterial: "AddMaterial",
    CreateProgram: "Chương trình mới",
    CreateRelease: "CreateRelease",
    AddTerminal: "AddTerminal",
    CreateAccount: "CreateAccount",
    Percent: "Percent",
    TerminalName: "Tên thiết bị",
    ReleaseSchedule: "ReleaseSchedule",
    status: "Trạng thái",
    operate: "Vận hành",
    retransmission: "Rtns",
    Cancel: "Hủy",
    CancelAll: "Hủy tất cả",
    AllRetransmission: "AllRtns",
    ClearanceToComplete: "ClearComplete",
    RemoveAll: "RemoveAll"
  },
  basics: {
    Cancel: "Hủy bỏ",
    Confirm: "Xác nhận",
    en: "EN",
    zh: "ZH",
    PleaseSelect: "Vui lòng chọn",
    PleaseInput: "Please input",
    materialCatalogue: "Material Catalogue",
    structureGrouping: "Nhóm cấu trúc",
    inStreamType: "Loại luồng trực tuyến"
  },
  public: {
    search: "Nhập từ khóa truy vấn"
  },
  router: {
    help: "Help",
    material: "MaterialManage",
    programme: "ProgrammeManage",
    editProgramme: "EditProgramme",
    publishProgramme: "PublishProgramme",
    terminal: "TerminalManage",
    check: "CheckManage",
    checkMaterial: "Đánh giá tài liệu",
    checkProgramme: "Đánh giá chương trình",
    checkPublish: "Đăng bài đánh giá",
    log: "LogManage",
    logLogin: "LogLogin",
    logOperation: "LogOperation",
    logTerminal: "LogTerminal",
    seniorManagement: "SeniorManagement",
    organization: "Cấu trúc",
    userManage: "UserManage",
    RoleManage: "RoleManage",
    systemLayout: "SystemLayout",
    nodeManage: "NodeManage",
    reviewSet: "ReviewSet",
    softwareLicence: "SoftwareLicence"
  },
  device: {},
  explorer: {
    clickUpload: "Drag files to here, or <em>click to Upload</em>",
    sizeLimit: "single file not exceed ",
    video: "Video",
    picture: "Hình ảnh",
    uploadFiles: "Tải tệp lên",
    newFolder: "Thư mục mới",
    deleteFiles: "Delete files",
    materialAll: "All materials loaded",
    materialsLoaded: "Click to load material",
    move: "Di chuyển",
    copy: "Sao chép",
    delete: "Xóa",
    all: "Chọn tất cả",
    name: "Tên",
    resolution: "Độ phân giải",
    fileSize: "Kích thước tệp tin",
    creationTime: "Thời gian sáng tạo",
    operate: "Vận hành",
    FolderName: "Tên thư mục",
    deleteFile: "IF delete currently selected file?",
    BackEdit: "Quay lại trình chỉnh sửa",
    FileMove: "Tẩy tệp tin",
    FileCopy: "File Copy",
    StartAll: "Chạy tất cả",
    StopAll: "Dừng tất cả",
    EmptyFinish: "Trống",
    CancelAll: "Hủy tất cả",
    NoFiles: "Không có tệp tải lên",
    Status: "Trạng thái",
    Check: "Kiểm tra",
    Stop: "Dừng",
    Start: "Start",
    Cancel: "Hủy",
    finish: "Hoàn thành"
  },
  log: {
    export: "Xuất",
    selectDevice: "Chọn thiết bị",
    deviceSn: "Seri thiết bị",
    operateTime: "Thời gian hoạt động",
    operateUser: "Người dùng vận hành",
    function: "Chức năng",
    describe: "Mô tả",
    dateArr: "Phạm vi ngày",
    startDate: "Ngày bắt đầu",
    endDate: "End date",
    search: "Please enter query keyword!",
    searchTips: "Vui lòng chọn thiết bị để truy vấn",
    loadingTips: "日志获取中，请稍后",
    no: "Số Seri",
    content: "Nội dung",
    operateObj: "Đối tượng hoạt động",
    operateContent: "Thông tin hoạt động",
    selectTips1: "Chỉ hỗ trợ truy vấn thông tin trong vòng 3 tháng",
    searchTips1: "Vui lòng chọn một thiết bị, xác định phạm vi thời gian và truy vấn",
    exportTips: "Chỉ dữ liệu trong phạm vi truy vấn có thể được xuất"
  },
  login: {
    Login: "Login",
    memberRegister: "Member register",
    ForgetThePassword: "Forget the password?",
    NoLogin: "No login for seven days",
    verification: "Please enter the verification code",
    account: "Please enter your account",
    password: "Vui lòng nhập mật khẩu",
    helpDocument: "Help Document"
  },
  manage: {},
  review: {
    Screenshot: "Hình ảnh",
    ProgramName: "Tên chương trình",
    Structure: "Cấu trúc",
    Resolution: "Độ phân giải",
    CreationTime: "Thời gian sáng tạo",
    operate: "Vận hành",
    Review: "Đánh giá",
    Check: "Kiểm tra",
    ProgramMaterial: "Tài liệu chương trình",
    ProgramPreview: "Đánh giá chương trình",
    ReviewContent: "Vui lòng nhập nội dung đánh giá",
    Approved: "Chấp thuận",
    RejectReview: "Từ chối đánh giá",
    DeleteAll: "Confirm delete all?",
    Name: "Tên",
    Size: "Size",
    Preview: "Preview",
    ProgramReview: "Đánh giá chương trình",
    ReasonRefusal: "Please fill in the reason for refusal!",
    number: "No release ticket number is selected",
    review: "Đánh giá",
    enterKey: "Nhập từ khóa",
    screenshot: "Ảnh chụp màn hình",
    name: "Tên",
    group: "Tổ chức",
    createTime: "Thời gian gửi",
    publisher: "Nhà xuất bản",
    check: "Kiểm tra",
    pass: "Chấp thuận",
    reject: "Từ chối",
    materialCheck: "Đánh giá tài liệu",
    pleaseInputContent: "Vui lòng nhập nội dung đánh giá",
    approve: "Chấp thuận",
    rejectReview: "Từ chối đánh giá",
    releaseReview: "Đăng bài đánh giá",
    resonForReject: "Vui lòng nhập lý do từ chối",
    all: "Tất cả",
    waitReview: "Đang đánh giá",
    approves: "Cho qua",
    selectTips: "请至少选择一条素材",
    selectTips1: "Only supports query data within three months",
    deleteTips: "确认全部删除?",
    deleteRecord: "Xóa bản ghi",
    singleNo: "Số đơn",
    loop: "Vòng lặp lại",
    timming: "Thời gian",
    instream: "Trong luồng trực tuyến",
    noAdap: "Không tương thích",
    adap: "Kích thước màn hình tương thích"
  },
  schedule: {
    Screenshot: "Hình ảnh",
    ProgramName: "Tên chương trình",
    Structure: "Cấu trúc",
    Resolution: "Độ phân giải",
    CreationTime: "Thời gian sáng tạo",
    operate: "Vận hành",
    AllLoaded: "All loaded",
    materialsLoaded: "Click to load material",
    NewProgram: "New program",
    DelProgram: "Xóa vĩnh viễn chương trình đã chọn?",
    DeleteMedia: "Xóa phương tiện",
    DeleteProgram: "Xóa các chương trình",
    loop: "Vòng lặp lại",
    timpingPlay: "Hẹn giờ chạy",
    emerPlay: "Chèn khẩn cấp",
    releaseRecord: "Đăng bản ghi",
    releaseMan: "Quản lý bài đăng",
    playNo: "Số bài đăng",
    group: "Tổ chức",
    releaseType: "Loại bài đăng",
    releaseNow: "Đăng bài ngay",
    releaseTim: "Thời gian đăng bài",
    publisher: "Nhà xuất bản",
    review: "Đánh giá",
    pedReview: "Đang đánh giá",
    noReview: "Không đánh giá",
    noPass: "Không cho qua",
    pass: "Chấp thuận",
    waitRelease: "Đã đăng bài",
    expird: "Đã hết hạn",
    detail: "Chi tiết",
    delete: "Xóa",
    deletePlay: "Xóa chương trình",
    deletePlayTip: "Xóa vĩnh viễn chương trình đã chọn?",
    keyWords: "Vui lòng nhập từ khóa",
    noSelectTip: "Không có bản ghi phát hành được chọn",
    addPlay: "Thêm chương trình",
    selectProgram: "Chọn danh sách chương trình",
    delPro: "Xóa chương trình",
    delProTip: "Xóa sạch toàn bộ chương trình?",
    screenshot: "Ảnh chụp màn hình",
    proName: "Tên chương trình",
    structure: "Cấu trúc",
    resolution: "Độ phân giải",
    createTime: "Thời gian sáng tạo",
    noProgram: "Hiện tại không có chương trình",
    moveDown: "Không thể di chuyển xuống nữa",
    moveUp: "Không thể di chuyển lên nữa",
    tips: "Gợi ý",
    playList: "Danh sách phát",
    terminalList: "Danh sách thiết bị",
    releaseProp: "Đăng bài thuộc tính",
    offline: "Ngoại tuyến",
    timimgPlan: "定时发布",
    user: "User",
    terminalName: "Tên thiết bị",
    terminalState: "Trạng thái thiết bị",
    publishSate: "Đăng trạng thái",
    planModole: "播放模式",
    playStrategy: "发布策略",
    playPlan: "Chạy kế hoạch",
    playCount: "Số lần chạy",
    playsCount: "Số lần chạy liên tiếp",
    pleaseSelect: "Vui lòng chọn",
    playTimes: "Thời gian chạy",
    conPlayTime: "Thời gian chạy liên tục",
    publish: "Đăng bài",
    customize: "Tùy chỉnh",
    once: "once",
    twice: "twice",
    treeTimes: "three times",
    fourTimes: "four times",
    fiveTimes: "five times",
    sixTimes: "six times",
    sevenTimes: "seven times",
    eightTimes: "eight times",
    nineTimes: "nine times",
    tenTimes: "ten times",
    countTips: "Số lần tối thiểu phải là 1",
    pubSuccessTip: "Đăng bài thành công",
    selectTip1: "Vui lòng chọn ít nhất 2 chương trình",
    planPre: "Đánh giá chương trình",
    addPlayStep: "Thêm các bước kế hoạch",
    selectDate: "Chọn ngày giờ",
    instreamResver: "Phát trực tiếp dự phòng",
    instreamNow: "Phát trực tiếp ngay",
    selectTimeTips: "Thời gian chọn không được sớm hơn thời gian hiện tại",
    palyTime: "Thời gian chạy",
    selectStartTime: "选择开始时间",
    selectEndTime: "选择结束时间",
    conserLoop: "Số chu kỳ vòng lặp lại",
    validDate: "Ngày khả dụng",
    date: "Ngày",
    daily: "Hằng ngày",
    startTimeTips: "Thời gian bắt đầu không được trễ hơn thời gian kết thúc",
    endTimeTips: "Thời gian kết thúc không được sớm hơn thời gian bắt đầu",
    startDateTips: "开始日期不能晚于结束日期",
    endDateTips: "Ngày kết thúc không được sớm hơn ngày bắt đầu",
    saveAplan: "Giữ ít nhất một kế hoạch",
    check: "Kiểm tra",
    planSize: "Kích thước chương trình",
    planName: "Tên bài đăng",
    leastTime: "失效日期",
    NewProgramInfor: "新增节目信息"
  },
  system: {
    StructureName: "Tên cấu trúc",
    Operate: "Vận hành",
    NewStructure: "Cấu trúc mới",
    DeleteStructure: "Xóa cấu trúc",
    Structure: "Cấu trúc",
    MsgDeleteStructure: "Xóa vĩnh viễn hiện tại?",
    OnDevice: "Turn on device",
    OffDevice: "Turn off device",
    inquiry: "IF",
    on: "on",
    off: "off",
    slaveDevice: "the current or slave device",
    CloseCurrent: "Close current",
    CloseSlave: "Close slave",
    OpenCurrent: "Open current",
    OpenSlave: "Open slave",
    Account: "Tài khoản",
    Name: "Tên",
    Role: "Vai Trò",
    Grade: "Cấp",
    Remark: "Nhận xét",
    RoleName: "Tên vai trò",
    Password: "Mật khẩu",
    ConfirmPass: "Xác nhận mật khẩu",
    Mail: "Địa chỉ email",
    DeleteUser: "Xóa người dùng",
    DeleteRole: "Permanently delete current role",
    UnblockDevice: "Unblock device",
    banDevice: "Ban device",
    Unblock: "Unblock",
    ban: "Forbidden",
    BanTheCurrent: "Ban the current",
    BannedAffiliate: "Banned affiliate",
    ReleaseTheCurrent: "Release the current",
    ReleaseTheSubordinate: "Release the subordinate",
    AddUser: "Thêm người dùng",
    ModifyUser: "Sửa đổi người dùng",
    inputPassword: "Vui lòng nhập mật khẩu xác nhận",
    noPassword: "Passwords entered twice do not match!",
    inputName: "Vui lòng nhập tên",
    RoleEmpty: "Tên vai trò không được để trống",
    StructureEmpty: "Structure name cannot empty",
    AccountEmpty: "Tài khoản không được để trống",
    AccountAstrict: "Account only contain numbers, letters, and underscores!",
    AccountLength: "Please set account length 3~20 characters!!",
    AccountRegistered: "Current account has been registered, please re-enter!",
    AddRole: "Thêm vai trò",
    RoleRemark: "Nhận xét vai trò",
    RightConfig: "Right config",
    DelRole: "Xóa vai trò",
    imageSize1: "Đề xuất 920x940 pixels ở định dạng PNG",
    ReplacePicture: "Thay thế hình ảnh",
    LoginLogo: "Logo trang đăng nhập",
    imageSize2: "Đề xuất 360x80 pixels ở định dạng PNG",
    SystemLogo: "Logo trang hệ thống",
    systemSettings: "Các cài đặt hệ thống khác",
    configInformation: "Thông tin cấu hình khác",
    DailyLimit: "Giới hạn ứng dụng hàng ngày",
    UploadedType: "Uploaded avatar image can only PNG format!",
    UploadedSize: "Kích thước của ảnh đại diện tải lên không được vượt quá 2MB!",
    addNode: "Add node",
    EnglishName: "EnglishName",
    ChineseName: "ChineseName",
    delNode: "Permanently delete current role ?",
    AuthorizationType: "Loại mã ủy quyền",
    Model: "Model",
    Date: "Ngày",
    AuthorizationCode: "Mã ủy quyền",
    NewAccounts: "新建账号",
    clearTips1: "Whether to clear all current reviewers?",
    clearTips2: "Whether to clear current reviewer?",
    selectReviewer: "Chọn người đánh giá",
    noReviers: "Không cho phép người đánh giá không liên quan",
    createTips: "Vui lòng tạo tài khoản đánh giá",
    sameReviwers: "Tổ chức tiếp theo chia sẻ cùng người đánh giá",
    email: "Địa chỉ email",
    phone: "Điện thoại",
    lastLogin: "Lần đằng nhập cuối",
    remark2: "Địa chỉ công ty",
    resetPwd: "Đặt lại mật khẩu",
    subUser: "Người dùng cấp dưới",
    NumOfTerminals: "Số lượng thiết bị",
    NumOfPro: "Số lượng chương trình",
    editPwd: "Thay đổi mật khẩu",
    oriPwd: "Mật khẩu ban đầu",
    newPwd: "Mật khẩu mới",
    confirmPws: "Xác nhận mật khẩu",
    modifyInfo: "Sửa đổi thông tin",
    changeNick: "Thay đổi biệt danh",
    changeEmail: "Thay đổi email",
    personalCenter: "Trung tâm cá nhân",
    enterOriPwd: "Nhập mật khẩu ban đầu",
    enterNewPwd: "Nhập mật khẩu mới",
    confirmPwd: "Vui lòng xác nhận mật khẩu",
    enterNick: "Vui lòng nhập biệt danh",
    pwdNoPass: "Mật khẩu không khớp",
    changePwdSucc: "Thay đổi mật khẩu thành công",
    modiSuccess: "Sửa đổi thành công",
    modiFail: "Sửa đổi thất bại",
    noSet: "Is not set",
    PleaseInputEmail: "Nhập email của bạn"
  },
  terminal: {
    treeTitle: "Nhóm cấu trúc",
    Details: "Chi tiết",
    online: "Trực tuyến",
    offline: "Ngoại tuyến",
    list: "Danh sách",
    card: "Biểu đồ",
    map: "Bản đồ",
    keyWord: "Nhập từ khóa",
    refresh: "Làm mới",
    add: "Thêm",
    delete: "Xóa",
    deviceName: "Tên thiết bị",
    remark: "Nhận xét",
    resolution: "Độ phân giải",
    types: "Loại",
    version: "Số phiên bản",
    status: "Trạng thái",
    operate: "Vận hành",
    edit: "Sửa đổi",
    loading: "Đang tải",
    allSelect: "Chọn toàn bộ",
    selected: "Đã chọn",
    selectAll: "Chọn tất cả trên trang này",
    selectInMap: "Vui lòng chọn vị trí thiết bị trên bản đồ",
    structure: "Cấu trúc",
    selectGroup: "Chọn cấu trúc",
    selectSize: "Vui lòng chọn độ phân giải",
    customize: "Tùy chỉnh",
    followTerminal: "Theo dõi thiết bị",
    selectSn: "Vui lòng chọn SN",
    deviceTip: "Tên thiết bị không được để trống",
    snTip: "Số sê-ri không được để trống",
    sizeTip: "Độ phân giải màn hình không được để trống",
    deviceType: "Loại thiết bị",
    cancel: "Hủy",
    confirm: "Xác nhận",
    delDevice: "Xóa thiết bị",
    delDevTip: "Xóa vĩnh viễn thiết bị đã chọn?",
    onlineTotal: "Thông kê trực tuyến",
    reboot: "Khởi động lại",
    offscreen: "Tắt màn hình",
    onscreen: "Bật màn hình",
    timeTask: "Lệnh thời gian",
    conBright: "Điều chỉnh độ sáng",
    conVoice: "Điều chỉnh âm thanh",
    relay: "Công tắc rơ-le",
    timeZone: "Hiệu chuẩn múi giờ",
    signalChange: "Chuyển đổi tín hiệu",
    synScreen: "Đồng bộ nhiều màn hình",
    timePlay: "Công tác hẹn giờ chạy",
    timeOn: "Công tác hẹn giờ",
    wTip: "Độ phân giải W trống",
    hTip: "Độ phân giải H trống",
    xTip: "Vị trí X trống",
    yTip: "Vị trí Y trống",
    mapTip: "Zoom out on the map to check the table information! ! !",
    selectTip: "Không có thiết bị được chọn",
    deviceDetail: "Chi tiết thiết bị",
    playList: "Danh sách phát",
    affi: "Affiliation:",
    screenType: "Loại màn hình",
    boxTime: "Đồng hồ thiết bị",
    noData: "Không có dữ liệu",
    currTimeZone: "Múi giờ hiện tại",
    deviceLan: "Ngôn ngữ thiết bị",
    deviceZoom: "Bộ nhớ",
    runState: "Trạng thái hoạt động",
    runTime: "Tiếp tục hoạt động:",
    lastHeart: "Nhịp tim gần đây",
    timeOrder: "Lệnh thời gian",
    comAddr: "Địa chỉ máy chủ",
    voice: "Âm thanh",
    birght: "Độ sáng",
    no: "Số sê-ri",
    proName: "Tên chương trình",
    power: "Rơ-le",
    milRefresh: "Tự động làm mới sau vài giây",
    viewPho: "Xem hình ảnh gốc",
    setTimeZone: "Đặt múi giờ",
    terminalUp: "Nâng cấp thiết bị",
    upType: "Phương pháp nâng cấp",
    cloudUp: "Nâng cấp qua đám mây",
    localUp: "Nâng cấp tệp cục bộ",
    clickUp: "Nhấp để tải lên",
    name: "Tên",
    type: "Model",
    verInfo: "Số phiên bản",
    schedule: "Lịch trình",
    noUp: "Không cần nâng cấp",
    waitStar: "Đợi bắt đầu",
    downExc: "Tải xuống ngoại lệ",
    downOK: "Tải xuống thành công",
    upTip: "Đang nâng cấp, sẽ tự khởi động lại khi hoàn tất",
    erroBack: "Phản hồi bất thường",
    downError: "Tải xuống thất bại",
    dowNum: "1 đã chọn",
    upTips1: "Note: In order to prevent data loss, please backup data, the device will restart auto after upgrade is completed,",
    upTips2: "please do not power off during upgrade process",
    upGr: "Nâng cấp",
    serverAddEdit: "Sửa đổi địa chỉ máy chủ",
    serEdTit: "Di chuyển thiết bị sang máy chủ mới",
    newAddr: "Địa chỉ máy chủ mới",
    test: "Thử nghiệm",
    user: "Tài khoản",
    psw: "Mật khẩu",
    remove: "Xóa",
    conRes: "Xác nhận khởi động lại",
    conOnSc: "Xác nhận mở màn hình",
    upTips3: "Vui lòng dùng tệp ZIP hoặc APK",
    testOk: "Thử nghiệm thành công",
    testFail: "Thử nghiệm thất bại",
    inputTips1: "Vui lòng nhập Tên người dùng và Mật khẩu",
    opOk: "Vận hành thành công",
    mapTip1: "Vui lòng đánh dấu thiết bị trên bản đồ",
    addDetail: "Chi tiết địa chỉ",
    lng: "Kinh độ",
    lat: "Latitude",
    matTip2: "Lấy địa chỉ thất bại, vui lòng thử lại",
    orderTip: "Confirm restart selected terminal screen?",
    orderTip1: "Confirm close selected terminal screen?",
    orderTip2: "Confirm to open selected terminal screen?",
    scSetting: "Cài đặt lịch hẹn",
    selectTip1: "Vui lòng chọn",
    selectTip2: "Thêm lệnh thời gian",
    selectTip3: "Vui lòng chọn dữ liệu mẫu hoạt động",
    conOrder: "Hướng dẫn vận hành",
    action1: "节目切换",
    action2: "Điều chỉnh độ sáng",
    action3: "Điều chỉnh âm lượng",
    action4: "Tắt màn hình",
    action5: "Bật màn hình",
    action6: "Chuyển đổi nguồn",
    action7: "Tắt Rơ-le",
    action8: "Bật Rơ-le",
    action9: "Tắt màn hình",
    action10: "Bật màn hình",
    value: "value",
    acVa1: "Ưu tiên HDMI",
    acVa2: "Tín hiệu không đồng bộ",
    acVa3: "Tín hiệu đồng bộ",
    excTime: "Thời gian thực hiện",
    dateOk: "Ngày khả dụng",
    noLimit: "Không giới hạn",
    isWeekLi: "Tuần khả dụng",
    oper: "Vận hành",
    newTem: "Tạo mẫu",
    savTem: "Lưu mẫu",
    addTem: "add scheduling template",
    temName: "Tên mẫu",
    temTip1: "Vui lòng nhập tên mẫu",
    relayOn: "Công tắc rơ-le",
    timeZoneSe: "Chọn múi giờ",
    hdmiSi: "Nguồn tín hiệu HDMI",
    inSin: "Nguồn tín hiệu nội bộ",
    openMulti: "Kích hoạt phát lại đồng bộ nhiều màn hình",
    gps: "Đồng bộ GPS",
    localW: "Đồng bộ mạng LAN",
    closeScreen: "Vô hiệu hóa phát lại đồng bộ nhiều màn hình",
    openTimePlay: "Bật tính năng phát lại theo thời gian",
    closeTimePlay: "Tắt tính năng phát lại theo thời gian",
    openTime: "Bật hẹn giờ",
    onTime: "Thời gian khởi động",
    offTime: "Thời gian tắt máy",
    excDate: "Ngày thực hiện",
    closeTime: "Đóng thời gian",
    onlyG: "Chỉ hỗ trợ các thiết bị quảng cáo",
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    noDeviceSelected: "Không có thiết bị được chọn",
    group: "Tổ chức",
    onlineNum: "Số lượng trực tuyến",
    offlineNum: "Số lượng ngoại tuyến",
    totalNum: "Số lượng thiết bị",
    noOrderExc: "Chưa có lệnh nào được thực hiện",
    createTime: "Thời gian sáng tạo",
    orderName: "Tên lệnh",
    aimDevice: "Thiết bị mục tiêu",
    orderStatus: "Trạng thái lệnh",
    timeOut: "Hết thời gian phản hồi",
    excSuccess: "Thực hiện thành công",
    sent: "Đã gửi",
    timeOpenNo: "Công tắc hẹn giờ: Chưa có dữ liệu",
    timeOpen: "Công tắc hẹn giờ: Bật",
    deviceOff: "Thiết bị ngoại tuyến",
    timeOpenTip: "Hẹn giờ chạy đang BẬT",
    timeCloseTip: "Hẹn giờ chạy đang TẮT",
    programList: "Danh sách chương trình",
    playTime: "Độ dài chương trình",
    loop: "Vòng lặp lại",
    excSta: "Tiêu chuẩn điều hành",
    timingPlay: "Hẹn giờ chạy",
    playCount: "Số lần chạy",
    proDelete: "Xóa chương trình",
    proDeleteTip: "Delete the program?",
    timePlayOpenTip: "Bắt đầu hẹn giờ phát thành công",
    timePlayCloseTip: "Tắt hẹn giờ phát thành công",
    programChangeTip: "Chuyển đổi chương trình thành công",
    programIsPlaying: "Chương trình đang phát",
    powerList: "Nguồn điện trên bo mạch",
    allOpen: "Mở tất cả",
    allClose: "Đóng tất cả",
    open: "Mở",
    close: "Đóng",
    mulCard: "Card đa năng",
    firstChannel: "Kênh thứ 1",
    secondChannel: "Kênh thứ 2",
    thirdChannel: "Kênh thứ 3",
    fourthChannel: "Kênh thứ 4",
    fifthChannel: "Kênh thứ 5",
    sixthChannel: "Sixth channel",
    seventhChannel: "Kênh thứ 7",
    eighthChannel: "Kênh thứ 8",
    syncToTerminal: "Đồng bộ thiết bị",
    allOpenTip: "Bật/Tắt card đa năng?",
    operComman: "Hướng dẫn vận hành",
    brigValue: "Âm thanh",
    method: "Phương pháp",
    speDate: "Ngày chỉ định",
    speWeek: "Tuần chỉ định",
    isDateLimit: "Giới hạn ngày đúng không?",
    isWeekLimit: "Giới hạn tuần đúng không?",
    edits: "Sửa",
    timingOn: "Bật lệnh thời gian",
    timingOff: "Tắt lệnh thời gian",
    addTimingCom: "Thêm lệnh thời gian",
    ban: "Forbidden",
    opend: "Mở",
    closed: "Đóng",
    timePlayTips: "定时播放中，无法切换",
    addDevice: "添加设备",
    deviceTypeTip: "请选择设备类型",
    key: "密匙",
    groupTips: "组织结构不能为空",
    least: "还剩",
    arrangeTip: "请选择0-100之间",
    saveSuccess: "保存成功",
    tempExit: "模板已存在,请更改名称",
    command: "命令",
    isSent: "已发送至",
    execSuccess: "Thực hiện thành công",
    sented: "Đã gửi",
    execFail: "Hết thời gian phản hồi",
    runStatus: "在线&开屏&在播",
    timeLimit: "请间隔",
    timeLimitTip: "秒,再进行操作,还剩",
    seconds: "秒",
    syncPlay: "Đồng bộ hóa chơi",
    signalStatus: "Tình trạng nguồn tín hiệu",
    automatic: "自动",
    zh: "简体中文",
    en: "英语",
    vn: "越南语",
    isopend: "Đã được mở",
    isclosed: "Không mở",
    syncGps: "GPS同步",
    syncNet: "网络同步",
    CentralControl: "Trung tâm kiểm soát",
    EditInstruction: "Chỉnh sửa hướng dẫn",
    AddInstruction: "Thêm hướng dẫn"
  },
  PE: {
    Setting: "Setting",
    Save: "Lưu",
    Release: "Đăng bài",
    Quit: "Thoát",
    ExitEditProgram: "Thoát sẽ hủy chương trình chỉnh sửa hiện tại",
    DragMaterial: "Drag the material file here",
    SaveWait: "Screenshots and saving, please wait ...",
    ProgramList: "Danh sách cửa sổ",
    multimedia: "Multimedia",
    AddMultimedia: "Add multimedia",
    Insert: "Chèn vào vị trí hiện tại",
    properties: "Đặc tính cửa sổ tài liệu",
    materialNull: "Vui lòng thêm tài liệu vào cửa sổ",
    Uploaded: "Uploaded",
    AllLoaded: "All loaded",
    materialsLoaded: "Click to load material",
    Text: "Văn bản",
    Digital: "Đồng hỗ kỹ thuật số",
    Analog: "Đồng hồ kim",
    Weather: "Thời tiết",
    Timing: "Đếm thời gian",
    Countdown: "Đếm ngược",
    StreamMedia: "Phương tiện phát trực tiếp",
    RSS: "RSS",
    Window: "Cửa sổ",
    Picture: "Hình ảnh",
    Video: "Video",
    Delete: "Xóa",
    Webpage: "Webpage",
    OneLayerUp: "Lên 1 lớp",
    OneLayerDown: "Xuống 1 lớp",
    Top: "Cạnh trên",
    Bottom: "Cạnh dưới",
    Full: "Toàn màn hình",
    HorizontalFull: "Toàn màn hình ngang",
    VerticalFull: "Toàn màn hình dọc",
    VerticalDown: "Dọc xuống",
    VerticalMiddle: "Dọc giữa",
    VerticalTop: "Dọc trên",
    HorizontalLeft: "Ngang trái",
    HorizontalCenter: "Tâm ngang",
    HorizontalRight: "Ngang phải",
    ProgramName: "Tên chương trình",
    Structure: "Cấu trúc",
    DeviceType: "Loại thiết bị",
    Resolution: "Độ phân giải",
    CustomResolution: "Độ phân giải tùy chỉnh",
    Device: "Device",
    SelectDevice: "Vui lòng chọn thiết bị",
    SelectTerminal: "Select publishing Terminal",
    TerminalName: "Tên thiết bị",
    DeviceStatus: "Trạng thái thiết bị",
    Offline: "Ngoại tuyến",
    AdaptiveScreen: "Kích thước màn hình tương thích",
    Tip: "Gợi ý",
    Thumbnail: "Thumbnail",
    Name: "Tên",
    version: "Version number",
    Title: "Title",
    TimerMode: "TimerMode",
    RelativeTime: "RelativeTime",
    AbsoluteTime: "AbsoluteTime",
    DisplayMode: "DisplayMode",
    Day: "Ngày",
    Hour: "Giờ",
    Minutes: "Phút",
    Second: "Second",
    EditStyle: "EditStyle",
    DisplayUsage: "EditStyle",
    ARow: "DT",
    MultiRow: "MT",
    FontFamily: "FontFamily",
    BackgroundColor: "BackgroundColor",
    FontColor: "FontColor",
    PlayTime: "Thời gian chạy",
    Describe: "Describe",
    HourMark: "HourMark",
    HourHand: "HourHand",
    MinutesMark: "MinutesMark",
    MinutesHand: "MinutesHand",
    background: "background",
    secondHand: "secondHand",
    DateAndDay: "DateAndDay",
    Display: "Display",
    SelectTimeZone: "SelectTimeZone",
    Scale: "Scale",
    ConstrainProportions: "ConstrainProportions",
    EnterTheAnimation: "EnterTheAnimation",
    TheEntryTime: "TheEntryTime",
    Data: "Ngày",
    Time: "Time",
    ChineseCalendar: "ChineseCalendar",
    Week: "Week",
    DateFormat: "DateFormat",
    Font: "Font",
    Roll: "Roll",
    FlipOver: "FlipOver",
    Motionless: "Motionless",
    RollingDirection: "RollingDirection",
    RollingVelocity: "RollingVelocity",
    FromLeftToRight: "FromLeftToRight",
    FromRightToLeft: "FromRightToLeft",
    FromTopToBottom: "FromTopToBottom",
    FromTheBottomUp: "FromTheBottomUp",
    Attribute: "Attribute",
    AttendedMode: "AttendedMode",
    EndToEnd: "EndToEnd",
    VolumeAdjust: "Điều chỉnh âm lượng",
    Duration: "Duration",
    Address: "Address",
    City: "City",
    Temp: "Nhiệt độ",
    WindPower: "Sức gió",
    Humidity: "Độ ẩm",
    DressingIndex: "Trang phục khuyến cáo",
    PlayTheWay: "PlayTheWay",
    TimeFormat1: "00:00:00:00",
    TimeFormat2: "00D00H00M00S"
  }
}